import { getUtilityClasses } from "./styles";
export const richTextFieldClasses = getUtilityClasses("RichTextField", [
    "root",
    "standard",
    "outlined",
    "menuBar",
    "menuBarContent",
    "content",
]);
